import { type PayoutAdminTraderV1ActivateTraderRequest } from '~/generated/payoutBackend/model';
import { type ConfigForm } from '../model';

export const transformValues = <T extends PayoutAdminTraderV1ActivateTraderRequest | ConfigForm>(values: T): T => {
    const convert = (value: unknown): unknown => {
        if (typeof value === 'number') {
            return String(value);
        }

        if (value === null || value === undefined) {
            return value;
        }

        if (Array.isArray(value)) {
            return value.map(convert);
        }

        if (typeof value === 'object') {
            return Object.fromEntries(Object.entries(value).map(([key, val]) => [key, convert(val)]));
        }

        return value;
    };

    return convert(values) as T;
};
